import { render, staticRenderFns } from "./Swiper.vue?vue&type=template&id=75fca4a0&scoped=true"
import script from "./Swiper.vue?vue&type=script&lang=js"
export * from "./Swiper.vue?vue&type=script&lang=js"
import style0 from "./Swiper.scss?vue&type=style&index=0&id=75fca4a0&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75fca4a0",
  null
  
)

export default component.exports